<template>
  <div class="forecast-tab">
    <div v-if="window.width < 992" class="forecast-tab__mob-dropdown mb-24">
      <div class="content-panel-flat panel-yellow">
        <div class="font-m mb-6">Pogoda dla regionu:</div>
        <div class="form-control-yellow">
          <a-config-provider :locale="pl_PL">
            <a-select
              class="mb-6 w-100"
              ref="select"
              v-model="selectedRegion"
              @change="handleRegionChange"
            >
              <a-select-option
                v-for="item in forecastCountries"
                :key="item.regionLocid"
                :value="item.regionLocid"
              >
                {{ item.countryName }} - {{ item.countryCapitol }}
              </a-select-option>
            </a-select>
          </a-config-provider>
        </div>
      </div>
    </div>

    <div v-else class="font-20 font-m mb-24">
	<a :href="selectedDomain"><span style="padding-right:10px;"><country-flag :country="selectedCountry" size="big" style="vertical-align:middle;"/></span> {{ getTitle() }} - pogoda i klimat</a>
    </div>

    <div class="forecast-tab__current-section mb-24">
      <div class="forecast-tab__row">
        <div class="forecast-tab__col forecast-tab__col_current">
          <div class="forecast-box current-item">
            <span v-if="isLoading" class="forecast-box__placeholder">
              <loading-spinner :size="24" />
            </span>
            <div class="mb-16 font-m">Dzisiaj, {{ getWeatherDay(0) }}</div>
            <div class="current-item__overall">
              <div class="current-item__icon">
                <span class="svg-icon d-inline-flex" aria-hidden="true">
                  <svg
                    class="svg-icon__svg"
                    width="86px"
                    height="86px"
                    focusable="false"
                  >
                    <use
                      :xlink:href="
                        `/img/static/svg-weather-sprites.svg#` +
                        getCurrentMeteoIcon()
                      "
                    ></use>
                  </svg>
                </span>
              </div>
              <div class="current-item__info">
                <div class="current-item__temp">
                  {{ getCurrentTemp() }} &#176;C
                </div>
                <div class="font-14 gray-40">
                  {{ getConditionDescription() }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="forecast-tab__col forecast-tab__col_current">
          <div class="forecast-box details-item">
            <span v-if="isLoading" class="forecast-box__placeholder">
              <loading-spinner :size="24" />
            </span>
            <div class="details-item__row">
              <div class="details-item__col">
                <div class="details-item__cell">
                  <span class="gray-40">Zachmurzenie:</span>
                  <span class="gray-60"> {{ getCurrentCloudcover() }}</span>
                </div>
                <div class="details-item__cell">
                  <span class="gray-40">Widoczność:</span>
                  <span class="gray-60">{{ getCurrentVisibility() }}</span>
                </div>
                <div class="details-item__cell">
                  <span class="gray-40">Wilgotność:</span>
                  <span class="gray-60">{{ getCurrentHumidity() }}</span>
                </div>
              </div>
              <div class="details-item__col">
                <div class="details-item__cell">
                  <span class="gray-40">Ciśnienie:</span>
                  <span class="gray-60">{{ getCurrentPressure() }}</span>
                </div>
                <div class="details-item__cell">
                  <span class="gray-40">Opady:</span>
                  <span class="gray-60">{{ getCurrentPrecipitation() }}</span>
                </div>
                <div class="details-item__cell">
                  <span class="gray-40">Wiatr:</span>
                  <span class="gray-60"
                    >{{ getCurrentWindSpeed() }} km/h
                    <a-icon
                      :style="{
                        transform: 'rotate(' + getCurrentWindDegree() + 'deg)',
                      }"
                      type="arrow-up"
                      class="c-blue-light"
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="forecast-tab__next-section">
      <div class="forecast-tab__row">
        <div
          class="forecast-tab__col forecast-tab__col_next mb-24"
          v-for="(i, idx) in 4"
          :key="idx"
        >
          <div class="forecast-box next-item">
            <span v-if="isLoading" class="forecast-box__placeholder">
              <loading-spinner :size="24" />
            </span>
            <div class="next-item__date font-m">
              <span>{{ getWeatherDayName(i) }}, </span>
              <span>{{ getWeatherDay(i) }}</span>
            </div>
            <div class="next-item__overall">
              <div class="next-item__icon">
                <span class="svg-icon d-inline-flex" aria-hidden="true">
                  <svg
                    class="svg-icon__svg"
                    width="64px"
                    height="64px"
                    focusable="false"
                  >
                    <use
                      :xlink:href="
                        `/img/static/svg-weather-sprites.svg#` + getMeteoIcon(i)
                      "
                    ></use>
                  </svg>
                </span>
              </div>

              <div class="next-item__temp">
                <div class="font-24">{{ getWeatherTempMaxC(i) }} &#176;C</div>
                <div class="font-14 gray-40">
                  Temp. w nocy: {{ getWeatherTempMinC(i) }}&nbsp;&#176;C
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <template v-if="window.width >= 992">
      <div class="regions-tags">
        <div class="font-18 font-m mb-24">Pogoda dla regionów:</div>

        <div class="regions-tags__wrapper">
          <div class="regions-tags__content">
            <div
              v-for="item in forecastCountries"
              :key="item.regionLocid"
              class="tag-btn-wrapper"
            >
              <button
                @click="regionChange(item)"
                class="btn btn-sm btn-rnd btn-white text-truncate"
                :class="selectedRegion == item.regionLocid ? 'focused' : null"
              >
                {{ item.countryName }} - {{ item.countryCapitol }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import CountryFlag from 'vue-country-flag';
import * as CONFIG from "../config.js";
import { forecastCountries } from "./forecastCountries";
import pl_PL from "ant-design-vue/lib/locale-provider/pl_PL";
import moment from "moment";
import "moment/locale/pl";
moment.locale("pl");

export default {
  name: "forecasts",
  props: {
    locid: String,
  },
  data: () => ({
    pl_PL,
    url: "/getvuemeteot1.json",
    forecastCountries: forecastCountries.countries,
    meteo: {},
    selectedRegion: "",
    selectedCountry: "",
    selectedDomain: "",
    isLoading: true,
    window: {
      width: 0,
    },
  }),
  components: {
	CountryFlag,
  },
  methods: {
    getTitle() {
      let dupa = this.forecastCountries
        .filter((obj) => obj.regionLocid === this.selectedRegion)
        .map((obj) => obj.countryName + " - " + obj.countryCapitol);
      return dupa[0];
    },
    handleRegionChange() {
      this.isLoading = true;
    },
    fixCountry(val) {
      if (val === 'kr') {
	this.selectedCountry = 'cu';
      } else if (val === 'ci') {
	this.selectedCountry = 'es';
      }
    },
    regionChange(item) {
      this.isLoading = true;
      this.selectedRegion = item.regionLocid;
      this.selectedCountry = item.regionLocid.substring(0,2).toLowerCase();
      this.fixCountry(this.selectedCountry);
      this.selectedDomain = "https://www." + item.domainURL;
    },
    getGeoMeteo() {
      let pars = "locids=" + this.selectedRegion;
      return axios
        .get(CONFIG.API_URL + this.url + "?" + pars, null, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json",
          },
        })
        .then((response) => {
          return response.data;
        })
        .catch((e) => {
          alert("ERROR" + e);
        });
    },
    getDayTime() {
      if (
        this.meteo.dni &&
        this.meteo.dni.dzien &&
        this.meteo.dni.dzien[0]["pora-dnia"]
      ) {
        return this.meteo.dni.dzien[0]["pora-dnia"];
      }
    },
    getCurrentCode() {
      if (
        this.meteo.data &&
        this.meteo.data.current_condition &&
        this.meteo.data.current_condition.weatherCode
      ) {
        return this.meteo.data.current_condition.weatherCode;
      } else {
        return "";
      }
    },
    getConditionDescription() {
      let code = this.getCurrentCode();
      let dayTime;

      if (this.getDayTime() === "night") {
        dayTime = "ConditionNight";
      } else {
        dayTime = "ConditionDay";
      }

      if (this.meteo.WeatherCodes) {
        let conditionText = this.meteo.WeatherCodes.filter(
          (obj) => obj["@id"] === code
        ).map((obj) => obj[dayTime]);

        return conditionText[0];
      }
    },
    getWeatherDay(i) {
      if (
        this.meteo.dni &&
        this.meteo.dni.dzien[i] &&
        this.meteo.dni.dzien[i].data
      ) {
        return this.meteo.dni.dzien[i].data;
      } else {
        return "";
      }
    },
    getWeatherDayName(i) {
      if (
        this.meteo.dni &&
        this.meteo.dni.dzien[i] &&
        this.meteo.dni.dzien[i]["dzien-tygodnia"]
      ) {
        return this.meteo.dni.dzien[i]["dzien-tygodnia"];
      } else {
        return "";
      }
    },
    getCurrentTemp() {
      if (
        this.meteo.data &&
        this.meteo.data.current_condition &&
        this.meteo.data.current_condition.temp_C
      ) {
        return this.meteo.data.current_condition.temp_C;
      } else {
        return "";
      }
    },
    getWeatherTempMinC(i) {
      if (
        this.meteo.data &&
        this.meteo.data.weather[i] &&
        this.meteo.data.weather[i].tempMinC
      ) {
        return this.meteo.data.weather[i].tempMinC;
      } else {
        return "";
      }
    },
    getWeatherTempMaxC(i) {
      if (
        this.meteo.data &&
        this.meteo.data.weather[i] &&
        this.meteo.data.weather[i].tempMaxC
      ) {
        return this.meteo.data.weather[i].tempMaxC;
      } else {
        return "";
      }
    },
    // getSunriseTime(i) {
    //   if (
    //     this.meteo.dni &&
    //     this.meteo.dni.dzien[i] &&
    //     this.meteo.dni.dzien[i].wschod
    //   ) {
    //     return this.meteo.dni.dzien[i].wschod;
    //   } else {
    //     return "";
    //   }
    // },
    // getSunsetTime(i) {
    //   if (
    //     this.meteo.dni &&
    //     this.meteo.dni.dzien[i] &&
    //     this.meteo.dni.dzien[i].zachod
    //   ) {
    //     return this.meteo.dni.dzien[i].zachod;
    //   } else {
    //     return "";
    //   }
    // },
    getCurrentPrecipitation() {
      if (
        this.meteo.data &&
        this.meteo.data.current_condition &&
        this.meteo.data.current_condition.precipMM
      ) {
        if (this.meteo.data.current_condition.precipMM == 0) {
          return "brak";
        } else {
          return this.meteo.data.current_condition.precipMM + " mm";
        }
      } else {
        return "";
      }
    },
    getWeatherPrecipitation(i) {
      if (
        this.meteo.data &&
        this.meteo.data.weather[i] &&
        this.meteo.data.weather[i].precipMM
      ) {
        if (this.meteo.data.weather[i].precipMM == 0) {
          return "brak";
        } else {
          return this.meteo.data.weather[i].precipMM + " mm";
        }
      } else {
        return "";
      }
    },
    getCurrentWindSpeed() {
      if (
        this.meteo.data &&
        this.meteo.data.current_condition &&
        this.meteo.data.current_condition.windspeedKmph
      ) {
        return this.meteo.data.current_condition.windspeedKmph;
      } else {
        return "";
      }
    },
    getWeatherWindSpeed(i) {
      if (
        this.meteo.data &&
        this.meteo.data.weather[i] &&
        this.meteo.data.weather[i].windspeedKmph
      ) {
        return this.meteo.data.weather[i].windspeedKmph;
      } else {
        return "";
      }
    },
    getCurrentWindDegree() {
      if (
        this.meteo.data &&
        this.meteo.data.current_condition &&
        this.meteo.data.current_condition.winddirDegree
      ) {
        return this.meteo.data.current_condition.winddirDegree;
      } else {
        return "";
      }
    },
    getWeatherWindDegree(i) {
      if (
        this.meteo.data &&
        this.meteo.data.weather[i] &&
        this.meteo.data.weather[i].winddirDegree
      ) {
        return this.meteo.data.weather[i].winddirDegree;
      } else {
        return "";
      }
    },
    getCurrentCloudcover() {
      if (
        this.meteo.data &&
        this.meteo.data.current_condition &&
        this.meteo.data.current_condition.cloudcover
      ) {
        if (this.meteo.data.current_condition.cloudcover == 0) {
          return "brak";
        } else {
          return this.meteo.data.current_condition.cloudcover + " %";
        }
      } else {
        return "";
      }
    },
    getCurrentVisibility() {
      if (
        this.meteo.data &&
        this.meteo.data.current_condition &&
        this.meteo.data.current_condition.visibility
      ) {
        if (this.meteo.data.current_condition.visibility == 0) {
          return "pełna";
        } else {
          return this.meteo.data.current_condition.visibility + " km";
        }
      } else {
        return "";
      }
    },
    getCurrentHumidity() {
      if (
        this.meteo.data &&
        this.meteo.data.current_condition &&
        this.meteo.data.current_condition.humidity
      ) {
        if (this.meteo.data.current_condition.humidity == 0) {
          return "brak";
        } else {
          return this.meteo.data.current_condition.humidity + " %";
        }
      } else {
        return "";
      }
    },
    getCurrentPressure() {
      if (
        this.meteo.data &&
        this.meteo.data.current_condition &&
        this.meteo.data.current_condition.pressure
      ) {
        if (this.meteo.data.current_condition.pressure == 0) {
          return "b.d.";
        } else {
          return this.meteo.data.current_condition.pressure + " hPa";
        }
      } else {
        return "";
      }
    },
    getCurrentMeteoIcon() {
      if (
        this.meteo.data &&
        this.meteo.data.current_condition &&
        this.meteo.data.current_condition.weatherIconUrl
      ) {
        return this.getImageName(
          this.meteo.data.current_condition.weatherIconUrl
        );
      } else {
        return "";
      }
    },
    getMeteoIcon(i) {
      if (
        this.meteo.data &&
        this.meteo.data.weather[i] &&
        this.meteo.data.weather[i].weatherIconUrl
      ) {
        return this.getImageName(this.meteo.data.weather[i].weatherIconUrl);
      } else {
        return "";
      }
    },
    getImageName(imageUrl) {
      if (imageUrl) {
        return imageUrl.split("\\").pop().split("/").pop().split(".")[0];
      } else {
        return "";
      }
    },
    handleResize() {
      this.window.width = window.innerWidth;
    },
  },
  created() {
    window.addEventListener("resize", this.handleResize, { passive: true });
    this.handleResize();
  },
  watch: {
    selectedRegion: function () {
      this.getGeoMeteo().then((data) => {
        this.meteo = data.MeteoData.MeteoDataElement;
        setTimeout(() => {
          this.isLoading = false;
        }, 250);
      });
    },
  },
  mounted() {
    this.selectedRegion = this.forecastCountries[0].regionLocid;
    this.selectedCountry = this.selectedRegion.substring(0,2).toLowerCase();
    this.fixCountry(this.selectedCountry);
    this.selectedDomain = "https://www." + this.forecastCountries[0].domainURL;
    this.getGeoMeteo().then((data) => {
      this.meteo = data.MeteoData.MeteoDataElement;
      this.isLoading = false;
    });
  },
};
</script>

<style lang="scss" scoped>
.forecast-box {
  background-color: lighten($gray-00, 2.5%);
  border-radius: 3px;
  height: 100%;
  padding: 18px 12px 20px;
  position: relative;

  @media (min-width: $screen-xxs) {
    padding: 24px 18px;
  }

  &__placeholder {
    background-color: lighten($gray-00, 2.5%);
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1;
  }
}

.forecast-tab {
  &__next-section {
    @media (max-width: $screen-sm-max) {
      margin-bottom: -12px;
    }

    @media (min-width: $screen-md) {
      margin-bottom: 6px;
    }
  }

  &__row {
    display: flex;
    flex-flow: row wrap;
    margin-right: -12px;
    margin-left: -12px;
  }

  &__col {
    padding-right: 12px;
    padding-left: 12px;

    &_current {
      width: 100%;

      @media (min-width: $screen-sm + 50) {
        width: 50%;
      }
    }

    &_next {
      width: 50%;

      @media (min-width: $screen-sm + 50) {
        width: 25%;
      }
    }
  }
}

.current-item {
  &__overall {
    display: flex;
    align-items: center;

    @media (max-width: $screen-xs-max + 50) {
      margin-bottom: -12px;
    }
  }

  &__icon {
    margin-right: 16px;

    @media (min-width: $screen-xxs) {
      margin-right: 26px;
    }
  }

  &__temp {
    font-size: 38px;
    line-height: 1.25;

    @media (min-width: $screen-xxs) {
      font-size: 44px;
    }
  }
}

.details-item {
  &__row {
    margin-right: -18px;
    margin-left: -18px;

    @media (min-width: $screen-xxs) {
      display: flex;
      align-items: center;
      height: 100%;
    }
  }

  &__col {
    padding-right: 18px;
    padding-left: 18px;
    width: 100%;

    @media (min-width: $screen-xxs) {
      width: 50%;
    }
  }

  &__cell {
    display: flex;
    justify-content: space-between;

    @media (min-width: $screen-sm + 50) {
      padding-top: 3px;
      padding-bottom: 3px;
    }
  }
}

.next-item {
  &__date {
    margin-bottom: 12px;
    overflow: hidden;

    > span {
      @include text-truncate();
      display: block;

      @media (min-width: $screen-xs) and (max-width: $screen-xs-max + 50),
        (min-width: $screen-lg) {
        display: inline;
      }
    }
  }

  &__overall {
    @media (min-width: $screen-xs) and (max-width: $screen-xs-max + 50),
      (min-width: $screen-md) {
      display: flex;
      align-items: center;
    }
  }

  &__icon {
    margin-bottom: 12px;

    @media (min-width: $screen-xs) and (max-width: $screen-xs-max + 50),
      (min-width: $screen-md) {
      margin-bottom: 0;
      margin-right: 18px;
    }
  }
}

.regions-tags {
  margin-bottom: -4px;

  &__wrapper {
    margin-right: -6px;
    margin-left: -6px;
  }

  &__content {
    display: flex;
    flex-flow: row wrap;
  }
}

.tag-btn-wrapper {
  padding: 0 6px 16px 6px;

  .btn {
    @media (max-width: $screen-xs-max) {
      display: block;
      text-align: left;
      width: 100%;
    }
  }
}
</style>
